export const WINDOW_KEYS = {
  CACHE_VIEW_PROMOTION: "CACHE_VIEW_PROMOTION",
  CACHE_FORM_START: "CACHE_FORM_START",
  CSRF_TOKEN: "CSRF_TOKEN",
};
/**
 *
 * @param {string} key
 * @returns {string | undefined}
 */
export const getWindow = (key) => window[key];
/**
 *
 * @param {string} key
 * @param {string} value
 * @returns {void}
 */
export const setWindow = (key, value) => (window[key] = value);

export const SESSION_STORAGE_KEYS = {
  CACHE_PAYMENT_START: "CACHE_PAYMENT_START",
  CACHE_FACEBOOK_PIXEL_PAYMENT_START: "CACHE_FACEBOOK_PIXEL_PAYMENT_START",
  CACHE_FACEBOOK_PIXEL: "CACHE_FACEBOOK_PIXEL",
  DEBUG_FACEBOOK_PIXEL: "DEBUG_FACEBOOK_PIXEL",
  CSRF_TOKEN: "CSRF_TOKEN",
};
/**
 *
 * @param {string} key
 * @returns {string | null}
 */
export const getSessionStorage = (key) => {
  if (storageAvailable("sessionStorage")) {
    return sessionStorage.getItem(key);
  }
  return window[key] ?? null;
};

/**
 *
 * @param {string} key
 * @param {string} value
 * @returns {void}
 */
export const setSessionStorage = (key, value) => {
  if (storageAvailable("sessionStorage")) {
    if (value === null) {
      sessionStorage.removeItem(key);
      return;
    }
    sessionStorage.setItem(key, value);
    return;
  }
  window[key] = value;
};

/**
 * reference: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#testing_for_availability
 * @param {any} type
 * @returns {boolean}
 */
export const storageAvailable = (type) => {
  /** @type {any} */
  let storage;
  const x = "__storage_test__";
  try {
    storage = window[type] || global[type];
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
};
